import React, { type FC, useEffect } from 'react';
import { TemplatePage } from './TemplatePage';
import { useEssentials } from '@wix/fe-essentials-standalone';
import { useTemplatesData } from '../../hooks/useTemplatesData';
import { usePageNavigate } from '../../hooks/usePageNavigate';

export const SingleTemplatePageWrapper: FC = () => {
  const { panoramaClient } = useEssentials();
  const { templates, setCurrentTemplate } = useTemplatesData();
  const { templateId, navigateToMainPage } = usePageNavigate();

  useEffect(() => {
    const navigateToMainPageOnFirstRender = () => {
      panoramaClient
        .errorMonitor()
        .reportError(
          new Error(
            'Navigate to main page on first render of app single template',
          ),
          { context: { templateId } },
        );
      navigateToMainPage();
    };

    if (!templateId) {
      navigateToMainPageOnFirstRender();
    }

    const matchedTemplate = templates.find(
      (template) => template.id === templateId,
    );

    const shouldNavigateToMainPage =
      templates?.length && (!matchedTemplate || !matchedTemplate?.previewUrl);
    if (shouldNavigateToMainPage) {
      navigateToMainPageOnFirstRender();
    } else {
      setCurrentTemplate(matchedTemplate);
    }
  }, [templates, templateId]);

  return <TemplatePage />;
};
